import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:submit-end', () => this.scrollToTop())
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', () => this.scrollToTop())
  }

  reset() {
    this.element.reset()

    // Limpiar los errores si existen
    const errorMessages = this.element.querySelectorAll('.error')
    errorMessages.forEach(error => error.remove())

    // Remover clases de error de los inputs
    const inputs = this.element.querySelectorAll('.is-invalid')
    inputs.forEach(input => input.classList.remove('is-invalid'))
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}